/*
LUCID LOOM — STEP 59C
EINBAUORT:
Onlineshop → Themes → … → Code bearbeiten
→ Assets → lucid-homepage-pro.js

KOMPLETTE DATEI ERSETZEN.

CSS + CORE werden jetzt viewport-/interaktionsgesteuert geladen.
*/
/*
LUCID LOOM — STEP 59
EINBAUORT IN SHOPIFY:
Onlineshop → Themes → … → Code bearbeiten → Assets → lucid-homepage-pro.js

KOMPLETTE DATEI ERSETZEN.

STEP 59:
- lucid-homepage-pro.css wird auf der Live-Homepage NICHT mehr initial geladen.
- CSS wird bei erster echter User-Interaktion vorab angefordert:
  touchstart / pointerdown / wheel / keydown / scroll.
- Falls eine .ll-home Section ohne vorherige Interaktion sichtbar wird,
  fordert der IntersectionObserver zuerst das CSS an.
- Der schwere JS-Core startet erst, sobald das CSS geladen oder fehlgeschlagen ist.
- Theme Editor lädt CSS + Core sofort.
- Kein Timer / kein Idle-Fallback im kritischen Hero-Load.

ERHALTEN:
- Step48 Viewport-gesteuerter Core
- globaler Bootstrap-/Core-Guard
- Core maximal 1x
- Theme-Editor Events
*/
(function () {
  'use strict';

  if (window.__LL_HOME_PRO_BOOTSTRAP_V59) return;
  window.__LL_HOME_PRO_BOOTSTRAP_V59 = true;

  var bootstrapScript = document.currentScript;
  var bootstrapSrc = bootstrapScript && bootstrapScript.src
    ? bootstrapScript.src
    : '';

  var cssRequested = false;
  var cssPromise = null;
  var coreRequested = false;
  var firstRootObserver = null;
  var interactionArmed = false;

  function replaceAssetName(targetName) {
    if (!bootstrapSrc) return '';

    try {
      var url = new URL(bootstrapSrc, window.location.href);
      url.pathname = url.pathname.replace(
        /lucid-homepage-pro\.js$/,
        targetName
      );
      return url.href;
    } catch (e) {
      return bootstrapSrc.replace(
        /lucid-homepage-pro\.js(?=\?|$)/,
        targetName
      );
    }
  }

  function getCssUrl() {
    return replaceAssetName('lucid-homepage-pro.css');
  }

  function getCoreUrl() {
    return replaceAssetName('lucid-homepage-pro-core.js');
  }

  function requestStyles() {
    if (cssPromise) return cssPromise;

    cssPromise = new Promise(function (resolve) {
      if (
        cssRequested ||
        document.querySelector('link[data-ll-home-pro-css]')
      ) {
        cssRequested = true;
        resolve();
        return;
      }

      var href = getCssUrl();
      if (!href) {
        resolve();
        return;
      }

      cssRequested = true;

      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.fetchPriority = 'low';
      link.setAttribute('data-ll-home-pro-css', '');

      link.addEventListener('load', resolve, { once: true });
      link.addEventListener('error', function () {
        /*
          Never block Homepage-Pro functionality permanently because of
          a temporary stylesheet/CDN failure.
        */
        resolve();
      }, { once: true });

      document.head.appendChild(link);
    });

    return cssPromise;
  }

  function requestCoreScript() {
    if (
      coreRequested ||
      window.__LL_HOME_PRO_CORE_REQUESTED ||
      window.__llHomeProSharedJsLoaded
    ) {
      return;
    }

    var src = getCoreUrl();
    if (!src) return;

    coreRequested = true;
    window.__LL_HOME_PRO_CORE_REQUESTED = true;

    if (firstRootObserver) {
      firstRootObserver.disconnect();
      firstRootObserver = null;
    }

    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.fetchPriority = 'low';

    script.addEventListener('error', function () {
      coreRequested = false;
      window.__LL_HOME_PRO_CORE_REQUESTED = false;
    }, { once: true });

    document.head.appendChild(script);
  }

  function requestCore() {
    requestStyles().then(requestCoreScript);
  }

  function disarmInteractionPreload() {
    if (!interactionArmed) return;
    interactionArmed = false;

    window.removeEventListener('touchstart', onFirstInteraction, true);
    window.removeEventListener('pointerdown', onFirstInteraction, true);
    window.removeEventListener('wheel', onFirstInteraction, true);
    window.removeEventListener('keydown', onFirstInteraction, true);
    window.removeEventListener('scroll', onFirstInteraction, true);
  }

  function onFirstInteraction() {
    disarmInteractionPreload();
    requestStyles();
  }

  function armInteractionPreload() {
    if (interactionArmed || cssRequested) return;
    interactionArmed = true;

    /*
      Passive/capture listeners only preload the tiny CSS asset.
      They do not prevent or alter scrolling, taps or keyboard input.
    */
    window.addEventListener('touchstart', onFirstInteraction, {
      passive: true,
      capture: true,
      once: true
    });
    window.addEventListener('pointerdown', onFirstInteraction, {
      passive: true,
      capture: true,
      once: true
    });
    window.addEventListener('wheel', onFirstInteraction, {
      passive: true,
      capture: true,
      once: true
    });
    window.addEventListener('keydown', onFirstInteraction, {
      capture: true,
      once: true
    });
    window.addEventListener('scroll', onFirstInteraction, {
      passive: true,
      capture: true,
      once: true
    });
  }

  /* LUCID LOOM — STEP 90
     Non-visual homepage helpers previously lived as inline scripts inside the
     main HTML document. This bootstrap is already deferred on the homepage, so
     keep the exact behaviors here without adding another request or timer. */
  function setupHeroScroll() {
    var triggers = Array.prototype.slice.call(
      document.querySelectorAll('[id^="HeroScrollTrigger-"]')
    );
    if (!triggers.length) return;

    var activeHeroes = [];

    function scrollOffset() {
      return window.innerWidth <= 749 ? -48 : -28;
    }

    function smoothScrollTo(element) {
      if (!element) return;

      var top = window.pageYOffset + element.getBoundingClientRect().top + scrollOffset();

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }

    function scrollToNext(hero, event) {
      if (event) event.preventDefault();

      var wrapper = hero.closest('.hero-wrapper');
      var next = wrapper ? wrapper.nextElementSibling : null;

      if (next) {
        smoothScrollTo(next);
        return;
      }

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }

    triggers.forEach(function (trigger) {
      if (trigger.dataset.llStep90HeroScrollReady === 'true') return;

      var suffix = trigger.id.replace(/^HeroScrollTrigger-/, '');
      var hero = document.getElementById('Hero-' + suffix);
      if (!hero) return;

      trigger.dataset.llStep90HeroScrollReady = 'true';
      activeHeroes.push({ hero: hero });

      trigger.addEventListener('click', function (event) {
        scrollToNext(hero, event);
      }, { passive: false });
    });

    if (!activeHeroes.length || window.__LL_STEP90_HERO_KEYBOARD_READY) return;
    window.__LL_STEP90_HERO_KEYBOARD_READY = true;

    document.addEventListener('keydown', function (event) {
      var target = event.target;
      var tag = target && target.tagName ? target.tagName.toLowerCase() : '';

      if (
        tag === 'input' ||
        tag === 'textarea' ||
        tag === 'select' ||
        (target && target.isContentEditable)
      ) {
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== ' ') return;

      for (var i = 0; i < activeHeroes.length; i += 1) {
        var item = activeHeroes[i];
        var rect = item.hero.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          scrollToNext(item.hero, event);
          return;
        }
      }
    });
  }

  function setupScrollTop() {
    if (window.__LL_SCROLL_TOP_CONSOLIDATED) return;
    window.__LL_SCROLL_TOP_CONSOLIDATED = true;

    var button = document.getElementById('ll-scroll-top');
    if (!button) return;

    var started = false;
    var mobileQuery = window.matchMedia
      ? window.matchMedia('(max-width: 749px)')
      : null;

    var rafId = 0;
    var autoScrolling = false;
    var autoTimer = 0;

    function isMobile() {
      return mobileQuery ? mobileQuery.matches : window.innerWidth <= 749;
    }

    function getScrollY() {
      var scrollingElement = document.scrollingElement || document.documentElement;

      return Math.max(
        window.pageYOffset || 0,
        window.scrollY || 0,
        (scrollingElement && scrollingElement.scrollTop) || 0,
        document.documentElement.scrollTop || 0,
        (document.body && document.body.scrollTop) || 0
      );
    }

    function update() {
      rafId = 0;

      var y = getScrollY();

      if (isMobile()) {
        if (y <= 2) {
          autoScrolling = false;
          clearTimeout(autoTimer);
        }

        button.classList.toggle('is-visible', y > 2 && !autoScrolling);
        return;
      }

      button.classList.toggle('is-visible', y > 350);
    }

    function requestUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    }

    function cancelAutoScrollOnManualInput() {
      if (!isMobile() || !autoScrolling) return;
      if (getScrollY() <= 4) return;

      autoScrolling = false;
      clearTimeout(autoTimer);
      requestUpdate();
    }

    function start() {
      if (started) return;
      started = true;

      window.removeEventListener('scroll', startOnFirstScroll);

      button.addEventListener('click', function () {
        if (isMobile()) {
          autoScrolling = true;
          button.classList.remove('is-visible');
          clearTimeout(autoTimer);

          autoTimer = setTimeout(function () {
            autoScrolling = false;
            requestUpdate();
          }, 1700);
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      window.addEventListener('orientationchange', function () {
        setTimeout(requestUpdate, 160);
      }, { passive: true });

      window.addEventListener('touchstart', cancelAutoScrollOnManualInput, {
        passive: true
      });
      window.addEventListener('wheel', cancelAutoScrollOnManualInput, {
        passive: true
      });
      window.addEventListener('keydown', function (event) {
        if (
          event.key === 'ArrowUp' ||
          event.key === 'ArrowDown' ||
          event.key === 'PageUp' ||
          event.key === 'PageDown' ||
          event.key === 'Home' ||
          event.key === 'End' ||
          event.key === ' '
        ) {
          cancelAutoScrollOnManualInput();
        }
      });

      if (mobileQuery) {
        if (mobileQuery.addEventListener) {
          mobileQuery.addEventListener('change', requestUpdate);
        } else if (mobileQuery.addListener) {
          mobileQuery.addListener(requestUpdate);
        }
      }

      requestUpdate();
    }

    function startOnFirstScroll() {
      start();
    }

    /* Exact live-homepage STEP73 behavior: first real scroll is the sole initializer. */
    window.addEventListener('scroll', startOnFirstScroll, {
      passive: true,
      once: true
    });
  }

  function setupStep90StaticHomepageUi() {
    if (window.Shopify && Shopify.designMode) return;
    setupHeroScroll();
    setupScrollTop();
  }

  function setup() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('.ll-home[data-section-id], [data-ll-step80-kind="homepage-pro"]')
    );

    if (!roots.length) return;

    if (window.Shopify && Shopify.designMode) {
      requestCore();
      return;
    }

    /*
      Give a real visitor's first navigation gesture a head start on CSS
      before the first below-fold Homepage-Pro section appears.
    */
    armInteractionPreload();

    if (!('IntersectionObserver' in window)) {
      /*
        Older browser fallback: functionality wins.
        Load styles + core immediately because viewport gating is unavailable.
      */
      requestCore();
      return;
    }

    firstRootObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          disarmInteractionPreload();
          requestCore();
          return;
        }
      }
    }, {
      rootMargin: '0px 0px',
      threshold: 0.01
    });

    roots.forEach(function (root) {
      firstRootObserver.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupStep90StaticHomepageUi();
      setup();
    }, { once: true });
  } else {
    setupStep90StaticHomepageUi();
    setup();
  }

  document.addEventListener('ll:step80:section-loaded', function (event) {
    var id = event && event.detail ? event.detail.sectionId : '';
    var scope = id ? document.getElementById('shopify-section-' + id) : null;
    if (!scope) return;
    if (scope.matches('.ll-home[data-section-id]') || scope.querySelector('.ll-home[data-section-id]')) {
      requestCore();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event &&
      event.target &&
      (
        (event.target.matches && event.target.matches('.ll-home[data-section-id]')) ||
        (event.target.querySelector && event.target.querySelector('.ll-home[data-section-id]'))
      )
    ) {
      requestCore();
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (
      event &&
      event.target &&
      (
        (event.target.matches && event.target.matches('.ll-home[data-section-id]')) ||
        (event.target.querySelector && event.target.querySelector('.ll-home[data-section-id]'))
      )
    ) {
      requestCore();
    }
  });
})();